import { render } from "./AddImages.vue?vue&type=template&id=3a73e5ba&scoped=true&ts=true"
import script from "./AddImages.vue?vue&type=script&lang=ts"
export * from "./AddImages.vue?vue&type=script&lang=ts"

import "./AddImages.vue?vue&type=style&index=0&id=3a73e5ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a73e5ba"]])

export default __exports__